import {FormBuilder, FormGroup} from "@angular/forms";

import {IsBefore} from "libraries/module/formbuilder/forms/utils/validators/isBefore.validator";
import {IsPast} from "libraries/module/formbuilder/forms/utils/validators/isPast.validator";
import {IsAfter} from "libraries/module/formbuilder/forms/utils/validators/isAfter.validator";
import {IValidator} from "libraries/module/formbuilder/forms/utils/validators/IValidator";
import {IDateFieldConfig} from "../../interfaces/IDateFieldConfig";
import {BookingSearchParameters} from "libraries/interfaces/IBookingSearchParameters";

export const TRAVELLER_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.person,
    BookingSearchParameters.hasMembershipCard
];
export const FARE_OPTIMISATION_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.actionForFareOptimisation,
    BookingSearchParameters.impactOnFareType,
    BookingSearchParameters.impactOnLuggage,
];
export const FARE_OPTIMISATION_CHECKBOX_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.hasFareOptimisation
];
export const FARE_OPTIMISATION_NUMBER_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.savingMin
];

export const VOUCHER_CHECKBOX_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.ticketMatchAll,
];

export const VOUCHER_DATE_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.ticketSectorBeginDate];
export const VOUCHER_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.ticketStatus,
    BookingSearchParameters.ticketFlightNumber,
];

export const VOUCHER_TEXT_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.ticketSectorFrom,
    BookingSearchParameters.ticketSectorTo,
    BookingSearchParameters.ticketSectorCarrier,
];

export const JOURNEY_DATE_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.begin,
    BookingSearchParameters.end,
    BookingSearchParameters.whenTravelReallyBegins
];
export const JOURNEY_TEXT_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.from,
    BookingSearchParameters.to,
    BookingSearchParameters.carrier,
    BookingSearchParameters.location
];
export const JOURNEY_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.seatStatus,
    BookingSearchParameters.ticketNativeStatus
];

export const BOOKING_DATE_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.whenCreated,
    BookingSearchParameters.whenLastUpdated,
    BookingSearchParameters.whenIssued,
    BookingSearchParameters.whenToIssue,
    BookingSearchParameters.whenOptionDrops,
    BookingSearchParameters.whenRetentionEnds,
    BookingSearchParameters.whenAgencyBookingCreated,
];
export const BOOKING_NUMBER_RANGE_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.pendingValueMin,
    BookingSearchParameters.pendingPercentageMin,
    BookingSearchParameters.pendingValueMax,
    BookingSearchParameters.pendingPercentageMax,
    BookingSearchParameters.paidValueMin,
    BookingSearchParameters.paidPercentageMin,
    BookingSearchParameters.paidValueMax,
    BookingSearchParameters.paidPercentageMax,
    BookingSearchParameters.dueValueMin,
    BookingSearchParameters.duePercentageMin,
    BookingSearchParameters.dueValueMax,
    BookingSearchParameters.duePercentageMax,
];

export const BOOKING_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.code,
    BookingSearchParameters.host,
    BookingSearchParameters.type,
    BookingSearchParameters.agency,
    BookingSearchParameters.agent,
    BookingSearchParameters.xStatus,
    BookingSearchParameters.midOffice,
    BookingSearchParameters.xType,
    BookingSearchParameters.issueStatus,
    BookingSearchParameters.retentionReason,
    BookingSearchParameters.retentionReason,
];

export const ACCOMODATION_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.placesToStay,
    BookingSearchParameters.propertyName,
    BookingSearchParameters.propertyReference,
];

export const ACCOMODATION_DATE_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.stayArrivalDate,
    BookingSearchParameters.stayBeginDate,
];

export const FLIGHT_CHECKBOX_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.sectorMatchAll,
];
export const FLIGHT_DATE_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.sectorBeginDate, BookingSearchParameters.sectorArrivalDate];
export const FLIGHT_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.sectorSeatStatus,
    BookingSearchParameters.sectorFlightNumber,
];

export const FLIGHT_TEXT_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.sectorFrom,
    BookingSearchParameters.sectorTo,
    BookingSearchParameters.sectorOperatingCarrier,
    BookingSearchParameters.sectorCarrier,
];

export const DOCUMENT_ARRAY_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.documentTicket];

export const PRICING_ARRAY_FIELD: BookingSearchParameters[] = [
    BookingSearchParameters.pricingRate,
    BookingSearchParameters.pricingXState,
    BookingSearchParameters.pricingFarebasis
];

export const SERVICE_ARRAY_FIELD: BookingSearchParameters[] = [BookingSearchParameters.serviceCode, BookingSearchParameters.serviceXStatus, BookingSearchParameters.hasSeatAssignment];

export const ROOT_ARRAY_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.text];

export const AFIDIUM_SERVICE_DATE_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.whenExecutedOperation];
export const AFIDIUM_SERVICE_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.serviceCodes,
    BookingSearchParameters.eligibilityStatuses,
    BookingSearchParameters.operationStatuses
];

export const AFIDIUM_SERVICE_FORM_ARRAY_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.afidiumServices];

export const QUALITY_CHECK_ARRAY_FIELDS: BookingSearchParameters[] = [BookingSearchParameters.qualityCheck];

export const AFIDIUM_REMARK_ARRAY_FIELDS: BookingSearchParameters[] = [
    BookingSearchParameters.remarkText,
    BookingSearchParameters.remarkRemark,
    BookingSearchParameters.remarkNote,
    BookingSearchParameters.remarkInvoicing,
    BookingSearchParameters.remarkOsi,
    BookingSearchParameters.remarkVendorAlert,
];

export const ALL_ARRAY_FIELDS: BookingSearchParameters[] = [
    ...TRAVELLER_ARRAY_FIELDS,
    ...BOOKING_ARRAY_FIELDS,
    ...JOURNEY_ARRAY_FIELDS,
    ...FLIGHT_ARRAY_FIELDS,
    ...DOCUMENT_ARRAY_FIELDS,
    ...SERVICE_ARRAY_FIELD,
    ...ROOT_ARRAY_FIELDS,
    ...AFIDIUM_SERVICE_ARRAY_FIELDS,
    ...AFIDIUM_REMARK_ARRAY_FIELDS,
    ...VOUCHER_CHECKBOX_FIELDS,
    ...ACCOMODATION_ARRAY_FIELDS,
    ...QUALITY_CHECK_ARRAY_FIELDS,
];

export const ALL_DATE_FIELDS: BookingSearchParameters[] = [
    ...JOURNEY_DATE_FIELDS,
    ...BOOKING_DATE_FIELDS,
    ...FLIGHT_DATE_FIELDS,
    ...AFIDIUM_SERVICE_DATE_FIELDS,
    ...VOUCHER_DATE_FIELDS,
    ...ACCOMODATION_DATE_FIELDS,
];
export const ALL_TEXT_FIELDS: BookingSearchParameters[] = [...JOURNEY_TEXT_FIELDS, ...FLIGHT_TEXT_FIELDS, ...VOUCHER_TEXT_FIELDS];
export const ALL_FORM_ARRAY_FIELDS: BookingSearchParameters[] = [...AFIDIUM_SERVICE_FORM_ARRAY_FIELDS];

export const DATE_FIELDS_CONFIG: IDateFieldConfig = {
    whenCreated: {
        maxDateOffset: 0,
    },
    whenLastUpdated: {
        maxDateOffset: 0,
    },
    whenIssued: {
        maxDateOffset: 0,
    },
    whenAgencyBookingCreated: {},
    whenToIssue: {},
    begin: {},
    end: {},
    whenTravelReallyBegins: {},
    sectorBeginDate: {},
    sectorArrivalDate: {},
    whenOptionDrops: {},
    whenRetentionEnds: {},
    whenExecutedOperation: {},
    ticketSectorBeginDate: {},
    stayArrivalDate: {},
    stayBeginDate: {},
};

export function dateRangeFormGroup(fb: FormBuilder): FormGroup {
    return fb.group({
        missing: [false],
        min: [''],
        max: [''],
    });
}


function textCodeFormGroup(fb: FormBuilder): FormGroup {
    return fb.group({
        text: [[]],
        code: [[]],
    });
}

export function formGroupConfig(fb: FormBuilder): FormGroup {
    return fb.group({
        [BookingSearchParameters.seatStatus]: [[]],
        [BookingSearchParameters.person]: [[]],
        [BookingSearchParameters.hasMembershipCard]: [null],
        [BookingSearchParameters.from]: textCodeFormGroup(fb),
        [BookingSearchParameters.to]: textCodeFormGroup(fb),
        [BookingSearchParameters.carrier]: textCodeFormGroup(fb),
        [BookingSearchParameters.begin]: dateRangeFormGroup(fb),
        [BookingSearchParameters.end]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenTravelReallyBegins]: dateRangeFormGroup(fb),
        [BookingSearchParameters.code]: [[]],
        [BookingSearchParameters.host]: [[]],
        [BookingSearchParameters.type]: [[]],
        [BookingSearchParameters.agent]: [[]],
        [BookingSearchParameters.agency]: [[]],
        [BookingSearchParameters.midOffice]: [[]],
        [BookingSearchParameters.xType]: [[]],
        [BookingSearchParameters.xStatus]: [[]],
        [BookingSearchParameters.issueStatus]: [[]],
        [BookingSearchParameters.retentionReason]: [[]],
        [BookingSearchParameters.whenCreated]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenAgencyBookingCreated]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenLastUpdated]: dateRangeFormGroup(fb),
        [BookingSearchParameters.text]: [[]],
        [BookingSearchParameters.whenIssued]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenToIssue]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenOptionDrops]: dateRangeFormGroup(fb),
        [BookingSearchParameters.whenRetentionEnds]: dateRangeFormGroup(fb),
        [BookingSearchParameters.pendingPercentageMin]: [null],
        [BookingSearchParameters.pendingValueMin]: [null],
        [BookingSearchParameters.pendingPercentageMax]: [null],
        [BookingSearchParameters.pendingValueMax]: [null],
        [BookingSearchParameters.paidPercentageMin]: [null],
        [BookingSearchParameters.paidValueMin]: [null],
        [BookingSearchParameters.paidPercentageMax]: [null],
        [BookingSearchParameters.paidValueMax]: [null],
        [BookingSearchParameters.duePercentageMin]: [null],
        [BookingSearchParameters.dueValueMin]: [null],
        [BookingSearchParameters.duePercentageMax]: [null],
        [BookingSearchParameters.dueValueMax]: [null],
        // We use `null` as sectorMatchAll value because :
        // - the checkbox has to be unchecked by default
        // - if the checkbox is untouched, its value must be omited from URL parameters
        [BookingSearchParameters.sectorMatchAll]: [null],
        [BookingSearchParameters.sectorFrom]: textCodeFormGroup(fb),
        [BookingSearchParameters.sectorTo]: textCodeFormGroup(fb),
        [BookingSearchParameters.sectorBeginDate]: dateRangeFormGroup(fb),
        [BookingSearchParameters.sectorArrivalDate]: dateRangeFormGroup(fb),
        [BookingSearchParameters.sectorSeatStatus]: [[]],
        [BookingSearchParameters.sectorFlightNumber]: [[]],
        [BookingSearchParameters.sectorCarrier]: textCodeFormGroup(fb),
        [BookingSearchParameters.sectorOperatingCarrier]: textCodeFormGroup(fb),
        [BookingSearchParameters.location]: textCodeFormGroup(fb),
        [BookingSearchParameters.documentTicket]: [[]],
        [BookingSearchParameters.pricingRate]: [[]],
        [BookingSearchParameters.pricingXState]: [[]],
        [BookingSearchParameters.pricingFarebasis]: [[]],
        [BookingSearchParameters.serviceCode]: [[]],
        [BookingSearchParameters.serviceXStatus]: [[]],
        [BookingSearchParameters.hasSeatAssignment]: [null],
        [BookingSearchParameters.whenExecutedOperation]: dateRangeFormGroup(fb),
        [BookingSearchParameters.afidiumServices]: fb.array([]),
        [BookingSearchParameters.remarkText]: [[]],
        [BookingSearchParameters.remarkRemark]: [[]],
        [BookingSearchParameters.remarkNote]: [[]],
        [BookingSearchParameters.remarkInvoicing]: [[]],
        [BookingSearchParameters.remarkOsi]: [[]],
        [BookingSearchParameters.remarkVendorAlert]: [[]],


        [BookingSearchParameters.ticketMatchAll]: [null],
        [BookingSearchParameters.ticketSectorFrom]: textCodeFormGroup(fb),
        [BookingSearchParameters.ticketSectorTo]: textCodeFormGroup(fb),
        [BookingSearchParameters.ticketSectorBeginDate]: dateRangeFormGroup(fb),
        [BookingSearchParameters.ticketStatus]: [[]],
        [BookingSearchParameters.ticketNativeStatus]: [[]],
        [BookingSearchParameters.ticketFlightNumber]: [[]],
        [BookingSearchParameters.ticketSectorCarrier]: textCodeFormGroup(fb),

        [BookingSearchParameters.stayArrivalDate]: dateRangeFormGroup(fb),
        [BookingSearchParameters.stayBeginDate]: dateRangeFormGroup(fb),
        [BookingSearchParameters.placesToStay]: [[]],
        [BookingSearchParameters.propertyName]: [[]],
        [BookingSearchParameters.propertyReference]: [[]],
        [BookingSearchParameters.hasFareOptimisation]: [null],
        [BookingSearchParameters.actionForFareOptimisation]: [[]],
        [BookingSearchParameters.savingMin]: [null],
        [BookingSearchParameters.impactOnLuggage]: [[]],
        [BookingSearchParameters.impactOnFareType]: [[]],

        [BookingSearchParameters.qualityCheck]: [[]],

    });
}

function setBeforePastValidator(name: string, form: FormGroup): IValidator[] {
    return [
        new IsBefore(form.get([name, 'max'])),
        new IsPast(),
    ];
}

function setAfterPastValidator(name: string, form: FormGroup): IValidator[] {
    return [
        new IsAfter(form.get([name, 'min'])),
        new IsPast(),
    ];
}

export function validatorConfig(form: FormGroup): { [key: string]: IValidator[] } {
    return {
        whenCreatedMin: setBeforePastValidator('whenCreated', form),
        whenCreatedMax: setAfterPastValidator('whenCreated', form),
        whenLastUpdatedMin: setBeforePastValidator('whenLastUpdated', form),
        whenLastUpdatedMax: setAfterPastValidator('whenLastUpdated', form),
        whenIssuedMin: setBeforePastValidator('whenIssued', form),
        whenIssuedMax: setAfterPastValidator('whenIssued', form),
        whenToIssueMin: [
            new IsBefore(form.get(['whenToIssue', 'max'])),
        ],
        whenToIssueMax: [
            new IsAfter(form.get(['whenToIssue', 'min'])),
        ],
        whenOptionDropsMin: [
            new IsBefore(form.get(['whenOptionDrops', 'max'])),
        ],
        whenOptionDropsMax: [
            new IsAfter(form.get(['whenOptionDrops', 'min'])),
        ],
        whenRetentionEndsMin: [
            new IsBefore(form.get(['whenRetentionEnds', 'max'])),
        ],
        whenRetentionEndsMax: [
            new IsAfter(form.get(['whenRetentionEnds', 'min'])),
        ],
        beginMin: [
            new IsBefore(form.get(['begin', 'max'])),
        ],
        beginMax: [
            new IsAfter(form.get(['begin', 'min'])),
        ],
        endMin: [
            new IsAfter(form.get(['end', 'min'])),
        ],
        endMax: [
            new IsBefore(form.get(['end', 'max'])),
        ],
        whenTravelReallyBeginsMin: [
            new IsAfter(form.get(['whenTravelReallyBegins', 'min'])),
        ],
        whenTravelReallyBeginsMax: [
            new IsAfter(form.get(['whenTravelReallyBegins', 'min'])),
        ],
        sectorBeginDateMin: [
            new IsAfter(form.get(['sectorBeginDate', 'min'])),
        ],
        sectorBeginDateMax: [
            new IsAfter(form.get(['sectorBeginDate', 'max'])),
        ],
        sectorArrivalDateMin: [
            new IsAfter(form.get(['sectorArrivalDate', 'min'])),
        ],
        sectorArrivalDateMax: [
            new IsAfter(form.get(['sectorArrivalDate', 'max'])),
        ],
        ticketSectorBeginDateMin: [
            new IsAfter(form.get(['ticketSectorBeginDate', 'min'])),
        ],
        ticketSectorBeginDateMax: [
            new IsAfter(form.get(['ticketSectorBeginDate', 'max'])),
        ],
        whenExecutedOperationMin: [
            new IsBefore(form.get(['whenExecutedOperation', 'max'])),
        ],
        whenExecutedOperationMax: [
            new IsAfter(form.get(['whenExecutedOperation', 'min'])),
        ],
    };
}
